export const ABOUT_ROUTER = '/about';
export const AUTH_ROUTER = '/auth';
export const ADD_WORD_ROUTER = '/addWord';
export const WORDS_ROUTER = '/words';
export const SIGNALS_ROUTER = '/signals'
export const HOME_ROUTER = '/';
export const DETAILS_WORD_ROUTER = '/detailWord';
export const DETAILS_SIGNAL_ROUTER = '/detailsSignal';
export const LOGOUT_ROUTER = '/logout';
export const PROFILE_ROUTER = '/profile';

const Routers = {
  AUTH_ROUTER,
  HOME_ROUTER,
  WORDS_ROUTER,
  ABOUT_ROUTER,
  ADD_WORD_ROUTER,
  SIGNALS_ROUTER,
  DETAILS_WORD_ROUTER,
  DETAILS_SIGNAL_ROUTER,
  LOGOUT_ROUTER,
  PROFILE_ROUTER
}

export default Routers
